import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import { IPublicClientApplication } from "@azure/msal-browser";
import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

function handleLogin(instance: IPublicClientApplication) {
  localStorage.removeItem("IdToken");
  localStorage.removeItem("Token");
  localStorage.removeItem("Name");
  localStorage.removeItem("Surname");
  localStorage.removeItem("Role");
  instance.loginRedirect(loginRequest).catch((e) => {
    console.error(e);
  });
}

/**
 * Renders a button which, when selected, will redirect the page to the login prompt
 */
const SignInButton = () => {
  const { instance } = useMsal();
  const { t } = useTranslation();

  return (
    <Box display="flex" justifyContent="center" alignItems="center" padding={2}>
      <Button variant="contained" onClick={() => handleLogin(instance)}>
        {t("Sign In")}
      </Button>
    </Box>
  );
};

export default SignInButton;
